<template>
  <div v-if="!modelBlog?.elements?.length">
    <span class="ui-banner bg-red-200 space-x-4 flex gap-2">
      <i class="fa fa-exclamation-triangle text-red-800" />
      <div class="space-y-2">
        <b class="text-red-800" v-text="t('empty.title')"/>
        <div class="text-sm" v-html="t('empty.description')"/>

        <div v-if="user.is_admin" class="pt-4">
          <ui-button
            v-if="user.is_admin"
            class="dark"
            text="Add item"
            @click="$emit('addbelow')"
            />
        </div>
      </div>
    </span>
  </div>
</template>

<script setup lang="ts">
defineEmits(['addbelow'])

const modelBlog = defineModel<Blog>()

const { t } = useI18n({
  messages: {
    en:{
      'empty':{
        title: 'This page does not contain any content',
        description: 'It looks like you found an empty page. This means that the page has been created but nobody cared to add any content to it yet.'
      }
    },
    de: {
      'empty':{
        title: 'Diese Seite enthält keinen Inhalt',
        description: 'Es sieht so aus, als hättest du eine leere Seite gefunden. Das bedeutet, dass die Seite erstellt wurde, aber noch niemand den Inhalt hinzugefügt hat.'
      }
    },
    es: {
      'empty':{
        title: 'Esta página no contiene contenido',
        description: 'Parece que encontraste una página vacía. Esto significa que la página ha sido creada, pero nadie se ha molestado en agregarle contenido todavía.'
      }
    },
    uk: {
      'empty':{
        title: 'Ця сторінка не містить жодного вмісту',
        description: 'Схоже, ви знайшли порожню сторінку. Це означає, що сторінка була створена, але ніхто ще не додав до неї жодного вмісту.'
      }
    },
  } as any
})
</script>
